import { FC, ReactNode } from 'react'
import { WagmiConfig } from 'wagmi'
import Web3Service from 'primsell-shared-layer/core/services/web3'

interface WagmiProviderProps {
  children: ReactNode
}

const WagmiProvider: FC<WagmiProviderProps> = ({ children }: WagmiProviderProps) =>
  Web3Service.walletConnect.config && <WagmiConfig config={Web3Service.walletConnect.config}>{children}</WagmiConfig>

export { WagmiProvider }
